import ReactGA from 'react-ga4';

export const sendEvent = (category:string, action:string, label:string, value: number | undefined |any ) => ReactGA.event({category, action, label , value});



